import { csv, extent, scaleLinear, stack, max, scaleOrdinal, select } from "d3";
import { useEffect, useState } from "react";
import fatalities from "../../Data/Caucasus/bar.csv";
import HoverTooltip from "../HoverTooltip";
import battles from "../../Media/Battles.svg";
import Bar from "./Bar";

const Bars = (props) => {
  const barsLength = props.width * 0.75;
  const legendWidth = props.width - barsLength;
  const borderWidth = 2;

  const [data, setData] = useState();
  const row = (d) => {
    d["Violence against civilians"] = +d["Violence against civilians"];
    d["Riots"] = +d["Riots"];
    d["Explosions/Remote violence"] = +d["Explosions/Remote violence"];
    d["Battles"] = +d["Battles"];
    d.total =
      +d["Violence against civilians"] +
      +d["Riots"] +
      +d["Explosions/Remote violence"] +
      +d["Battles"];
    return d;
  };
  useEffect(() => {
    csv(fatalities, row).then(setData);
  }, []);
  if (!data) return;

  const xValue = (d) => d.total;
  const xScale = scaleLinear()
    .domain([0, max(data, (d) => d.total)])
    .range([0, barsLength]);

  const colourScale = props.colourScale;

  const stackGenerator = stack().keys([
    "Violence against civilians",
    "Riots",
    "Explosions/Remote violence",
    "Battles",
  ]);

  const stackedData = stackGenerator(data, xValue);

  const showTooltipHandler = (type, value) => {
    const tooltip = document.querySelector("#hover-tooltip");
    tooltip.childNodes[0].innerHTML = `${type}: ${value} events`;
    tooltip.style.display = "block";
  };
  const setTooltipPosition = (event) => {
    const tooltip = document.querySelector("#hover-tooltip");
    tooltip.style.left = `${event.clientX + 20}px`;
    tooltip.style.top = `${event.clientY - 45}px`;
  };
  const hideTooltipHandler = () => {
    const tooltip = document.querySelector("#hover-tooltip");
    tooltip.style.display = "none";
  };

  const getWidth = (dataPoint) => {
    return xScale(dataPoint[0][1] - dataPoint[0][0]);
  };

  return (
    <div
      id="bars"
      style={{
        height: props.height,
        background: "#f0f0f0",
        boxSizing: "border-box",
        border: `${borderWidth}px solid #12425e`,
        borderLeft: 0,
        borderRight: 0,
        display: "flex",
      }}
    >
      <div
        className="chart-label"
        style={{
          width: legendWidth,
          display: "flex",
          alignItems: "center",
          gap:8,
          background: "#ffffff",
        }}
      >
        <img src={battles}></img>
        <div>
        <p style={{lineHeight:"1em",marginBottom:3}} className="f-med">
          <strong>{`${data[0].total.toLocaleString()} political violence events in 2022`}</strong>
          </p>
          <p className="f-small" style={{lineHeight:"1em",marginTop:5}}>
          <em>Hover for totals disaggregated by event type</em>
        </p>
        </div>
      </div>
      <div>
        <svg id="barchart" width={barsLength} height={props.height}>
          {stackedData.map((item, index) => {
            return (
              <Bar
                key={index}
                item={item}
                index={index}
                height={props.height - borderWidth * 2}
                getWidth={getWidth}
                colourScale={colourScale}
                xScale={xScale}
                showTooltipHandler={showTooltipHandler}
                setTooltipPosition={setTooltipPosition}
                hideTooltipHandler={hideTooltipHandler}
              />
            );
          })}
        </svg>
      </div>
      <HoverTooltip />
    </div>
  );
};

export default Bars;
